import { useEffect } from 'react'
import { isRecaptchaDisabled } from 'builder/utils/recapchaActions'

type RecaptchaProps = {
  showRecaptcha?: boolean
}

export const Recaptcha = (props: RecaptchaProps) => {
  const { showRecaptcha } = props

  const loadScript = () => {
    if (isRecaptchaDisabled()) {
      return
    }

    // to show after second time.
    const element = document.querySelector<HTMLElement>('.grecaptcha-badge')
    if (element) element.style.visibility = 'visible'

    if (window.grecaptcha) return

    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.GOOGLE_RECAPTCHA_KEY}`
    script.async = true
    script.onload = () => {}
    script.onerror = error => {
      console.error('Error loading reCAPTCHA script:', error)
    }
    document.body.appendChild(script)
    return script
  }

  useEffect(() => {
    const script = loadScript()

    return () => {
      // Cleanup script when component unmounts
      if (script && script.parentNode) {
        script.parentNode.removeChild(script)
      }

      const element = document.querySelector<HTMLElement>('.grecaptcha-badge')
      if (element) element.style.visibility = 'hidden'
    }
  }, [])

  return (
    <>
      {showRecaptcha ? (
        <div
          id="g-recaptcha_v2-container"
          style={{ position: 'absolute', zIndex: '999', top: '-60px', right: '0px' }}
        />
      ) : null}
    </>
  )
}
